const en = {
  workDoing: 'Working',
  shutdown: 'Shutdown',
  finish: 'Finish',
  undefined: 'Undefined',
  projectIntro: 'Project Introduction',
  projectInfo: 'project Information',
  address: 'Address',
  manager: 'Manager',
  telephone: 'Telephone',
  safetyOfficer: 'Safety Officer',
  constructionUnit: 'Construction Unit',
  overview: 'Overview',
  craneTotal: 'Crane Total',
  onlineTotal: 'Online Total',
  antiDevice: '110S Total',
  videoDevice: 'V610 Total',
  alarmMonitor: 'Alarm Monitor',
  alarmDetail: 'Alarm Detail',
  peccancyDetail: 'Peccancy Detail',
  todayStatistics: 'TodayStatistics',
  todayOnlineRate: 'TodayOnlineRate',
  dayToDay: 'DayToDay',
  todayAlarm: 'Today Alarm',
  times: 'Times',
  craneAvg: 'CraneAvg',
  todayPeccancy: 'Today OverLimit',
  todayHoisting: 'Today Hoisting',
  todayHours: 'Today Hours',
  alarmRanking: 'Alarm Ranking',
  alarm: 'Alarm',
  overLimit: 'Torque',
  craneInfo: 'Crane Information',
  craneName: 'Name',
  type: 'Type',
  flatTop: 'FlatTop',
  luffing: 'Luffing',
  hammerhead: 'Hammerhead',
  towerCraneHeight: 'CraneHeight',
  jibLength: 'jib Length',
  balanceLength: 'balance Length',
  sectionHeight: 'section Height',
  ratedLoad: 'Rated Load',
  factory: 'Manufacturer',
  model: 'Model',
  companyName: 'ZLX',
  mainHook: 'MainHook',
  jib: 'Jib',
  balance: 'Balance',
  cabin: 'Cabin',
  panorama: 'Panorama',
  title: 'Tower aircraft 3D monitoring large screen',
  introduce: 'Tower Crane housekeeper focuses on construction machinery safety',
  username: 'Username',
  password: 'Password',
  rememberPwd: 'Remember Pwd',
  login: 'Login',
  open: 'Open',
  close: 'Close',
  radius: 'Radius',
  slewing: 'Slewing',
  hook: 'Hook',
  load: 'Load',
  torque: 'Torque',
  safetyLoad: 'SafetyLoad',
  windSpeed: 'WindSpeed',
  runTime: 'RunTime',
  leftAntiCollision: 'leftAntiCollision',
  rightAntiCollision: 'rightAntiCollision',
  radiusOutAntiCollision: 'radiusOutAntiCollision',
  radiusInAntiCollision: 'radiusInAntiCollision',
  leftSwingZoning: 'leftSwingZoning',
  rightSwingZoning: 'rightSwingZoning',
  radiusOutZoning: 'radiusOutZoning',
  radiusInZoning: 'radiusInZoning',
  leftLimit: 'leftLimit',
  rightLimit: 'rightLimit',
  radiusOutLimit: 'radiusOutLimit',
  radiusInLimit: 'radiusInLimit',
  heightUpLimit: 'heightUpLimit',
  heightDownLimit: 'heightDownLimit',
  force: 'Load',
  loadMoment: 'LoadMoment',
  windowSpeed: 'windowSpeed',
  mainHookVideo: 'MainHook Video',
  jibVideo: 'Jib Video',
  balanceVideo: 'Balance Video',
  cabinVideo: 'Cabin Video',
  panoramaVideo: 'Panorama Video',
  interUserName: 'Enter Username',
  interPwd: 'Enter Password',
  interTitle: 'Title',
  interProjectAccount: 'Enter Project Account!',
  current: 'Current',
  temperature: 'Temperature',
  overload: 'Overload',
  smoke: 'Smoke',
  overhead: 'Overhead',
  disconnect: 'Disconnect',
  blackout: 'Blackout',
  leakage: 'Leakage',
  resi: 'Resi',
  branch: 'Branch',
  totalEnergy: 'Energy',
  powerUnit: 'Unit',
  resiValue: 'ResiValue',
  box: 'Box',
  noData: 'NoData'
}
export default en



// WEBPACK FOOTER //
// ./src/i18n/en.js